import React, { useEffect, useRef, useCallback, useMemo, useState } from 'react';
import TreeView from 'devextreme-react/tree-view';
import { useNavigation } from '../../contexts/navigation';
import { useScreenSize } from '../../utils/media-query';
import './SideNavigationMenu.scss';
import * as events from 'devextreme/events';
import { useAuth } from '../../contexts/auth';
import useAxiosPrivate, { axiosAdminPrivate } from '../../api/useAxios';

export default function SideNavigationMenu(props) {
  const {
    children,
    selectedItemChanged,
    openMenu,
    compactMode,
    onMenuReady
  } = props;

  const { user, setUser } = useAuth()

  const { isLarge } = useScreenSize();
  const axiosPrivate = useAxiosPrivate(axiosAdminPrivate)

  const [navigationList, setNavigationList] = useState([])

  const getMenus = async () => {

    try {
      const response = await axiosPrivate.get("/api/Menu/Tree/UserMenu")

      if (response.status === 200)
        if (response.data) {
          let result = response.data.data.map((item) => (
            {
              ...item,
              text: item.text,
              //path: item.path,
              icon: item.icon,
              expanded: isLarge,
              path: item.path && !(/^\//.test(item.path)) ? `/${item.path}` : item.path
            }
          ))
          return result
        }
    } catch (error) {
      console.log(error)
      return null
    }

  }

  useEffect(() => {

    getMenus().then((response) => {
      if (response) setNavigationList(response)

    })

  }, [user])

  function normalizePath() {
    //return navigationList;
    return navigationList.map((item) => (
      { ...item, expanded: isLarge, path: item.path && !(/^\//.test(item.path)) ? `/${item.path}` : item.path }
    ))

  }

  const items = useMemo(
    normalizePath,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user, navigationList]
  );

  const { navigationData: { currentPath } } = useNavigation();

  const treeViewRef = useRef(null);
  const wrapperRef = useRef();
  const getWrapperRef = useCallback((element) => {
    const prevElement = wrapperRef.current;
    if (prevElement) {
      events.off(prevElement, 'dxclick');
    }

    wrapperRef.current = element;
    events.on(element, 'dxclick', (e) => {
      openMenu(e);
    });
  }, [openMenu]);

  useEffect(() => {
    const treeView = treeViewRef.current && treeViewRef.current.instance;
    if (!treeView) {
      return;
    }
    if (currentPath === "/permission-required") {
      
      treeView.selectItem("");
      treeView.expandItem("");

    }
    else
      if (currentPath !== undefined) {
        treeView.selectItem(currentPath);
        treeView.expandItem(currentPath);
      }

    if (compactMode) {
      treeView.collapseAll();
    }
  }, [currentPath, compactMode, user]);


  return (
    <div
      className={'dx-swatch-additional side-navigation-menu'}
      ref={getWrapperRef}
    >
      {children}
      <div className={'menu-container'}>
        <TreeView
          ref={treeViewRef}
          items={items}
          keyExpr={'path'}
          selectionMode={'single'}
          focusStateEnabled={false}
          expandEvent={'click'}
          onItemClick={selectedItemChanged}
          onContentReady={onMenuReady}
          width={'100%'}
        />
      </div>
    </div>
  );
}
